import HeadingText from '@ancon/wildcat-ui/web/orderweb/HeadingText'
import clsx from 'clsx'

import { MenuSection } from '../../types'

import OutletMenuProductList from './OutletMenuProductList'
import styles from './OutletMenuSection.module.scss'

type OutletMenuSectionProps = {
  menuSection: MenuSection
  sectionIndex: number
}

export default function OutletMenuSection({
  menuSection,
  sectionIndex,
}: OutletMenuSectionProps) {
  const hasSubGroups = !!menuSection?.subGroups?.length

  return (
    <div
      id={`group-${sectionIndex}`}
      className={clsx(styles.container, {
        [styles.subGroupContainer]: hasSubGroups,
      })}
    >
      <HeadingText as="h2">{menuSection.name}</HeadingText>
      {hasSubGroups ? (
        menuSection.subGroups?.map((subGroup, index) => (
          <div
            id={`group-${sectionIndex}-sub-group-${index}`}
            key={subGroup.id}
            className={styles.subGroupWrapper}
          >
            <OutletMenuProductList
              productIds={subGroup?.products || []}
              title={subGroup.name}
            />
          </div>
        ))
      ) : (
        <OutletMenuProductList productIds={menuSection?.products || []} />
      )}
    </div>
  )
}
